import * as React from 'react';
import { cn } from '../../lib/utils';

export interface SwitchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  offLabel?: React.ReactNode;
  onLabel?: React.ReactNode;
}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ offLabel, onLabel, className, disabled, ...props }, ref) => {
    return (
      <label className={cn('inline-flex items-center gap-2 cursor-pointer select-none', disabled && 'opacity-50 cursor-not-allowed', className)}>
        {offLabel && <span className="text-sm text-muted-foreground">{offLabel}</span>}
        <span className="relative inline-flex">
          <input type="checkbox" ref={ref} disabled={disabled} className="peer sr-only" {...props} />
          <span className="h-5 w-9 rounded-full bg-input transition-colors peer-checked:bg-primary peer-focus-visible:ring-1 peer-focus-visible:ring-ring" />
          <span className="absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-background shadow transition-transform peer-checked:translate-x-4" />
        </span>
        {onLabel && <span className="text-sm text-foreground">{onLabel}</span>}
      </label>
    );
  }
);
Switch.displayName = 'Switch';

export { Switch };
